<div class="tw-flex tw-items-center tw-h-full tw-px-[20px]">
    <div
        class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-[20px]"
    >
        <button
            class="tw-absolute tw-top-4 tw-right-4 tw-text-gray-500 hover:tw-text-gray-700"
            (click)="closeDialog()"
        >
            <mat-icon>close</mat-icon>
        </button>
        <div
            class="tw-rounded-[16px] tw-shadow-lg tw-min-h-[205px] tw-w-[340px] md:tw-min-w-[340px] tw-flex tw-justify-center tw-items-center tw-bg-white"
        >
            <img class="tw-max-w-[235px]" [src]="miti?.image" alt="Miti-Logo" />
        </div>
        <div
            class="tw-w-full tw-text-center md:tw-text-left tw-max-w-[475px] tw-text-[#0F268F]"
        >
            <span class="!tw-font-semibold !tw-uppercase tw-text-[#0F268F]">{{
                miti?.prodFi
            }}</span>
            <h2 class="!tw-text-[22px] sm:!tw-text-[32px] !tw-mb-[40px]">
                {{ miti?.productName }}
            </h2>
            <p
                *ngIf="selectedLanguage === 'en'"
                class="!tw-text-[#8D8D8D] !tw-text-[13px]"
            >
                You are now leaving imSME. You're about to access the services
                of an agency. Any transaction made beyond will not be shown in
                imSME.
            </p>
            <p
                *ngIf="selectedLanguage === 'bm'"
                class="!tw-text-[#8D8D8D] !tw-text-[13px]"
            >
                Anda kini meninggalkan imSME. Anda akan mengakses perkhidmatan
                agensi. Sebarang transaksi yang dibuat di luar tidak akan
                ditunjukkan dalam imSME.
            </p>
            <a
                [attr.ga-event-id]="
                    miti.prodCode.toLowerCase() +
                    '_take_me_there_button_dcg_popup_click'
                "
                [attr.ga-event-category]="'Grants Button'"
                [attr.ga-event-label]="
                    miti.productName + ' Take Me There Button Click'
                "
                ga-track="track"
                [href]="miti?.url"
                target="_blank"
                class="tw-block tw-font-semibold tw-text-center tw-w-full tw-max-w-[70%] md:tw-max-w-[40%] tw-bg-[#FF8717] tw-text-white tw-rounded-full tw-shadow-lg tw-mx-auto md:tw-mx-0 tw-py-[15px]"
            >
                {{
                    selectedLanguage == "en"
                        ? "Take me there"
                        : "Bawa saya ke sana"
                }}
            </a>
        </div>
    </div>
</div>
